module.exports = __webpack_public_path__ + "static/media/icor-brand-small.baf0809e.png";